// extracted by mini-css-extract-plugin
export default {"section-title":"Contact_section-title__aCrKB","matter-item":"Contact_matter-item__0Tnwo"};